export const useCopyright = () => {
  const currentYear = new Date().getFullYear();
  const copyrightText = `${currentYear} Nurture Life, Inc.`;

  return {
    copyrightText,
    currentYear,
  };
};
